export default __webpack_public_path__ + "static/media/logo_openfinance.5442fa07.svg";